// @flow
import type { GlobalState } from "../../lib/types";
import { BackendModuleTypes, MessageTypes, ModuleTypes } from "../../lib/types";
import { getActiveModule, getLastMessageType } from "../../store";

export const getIsIAactive = (state: GlobalState) => {
  const activeModule = getActiveModule(state);
  return activeModule && activeModule.type === ModuleTypes.instantAnswers;
};

export const getIsIAFeedback = (state: GlobalState) => {
  return getLastMessageType(state) === MessageTypes.IA_FEEDBACK_MESSAGE && !getIsTooWrong(state);
};

export const getSuggestions = (state: GlobalState) => {
  return state.ia.suggestions;
};

export const getWrongAnswers = (state: GlobalState) => {
  return state.ia.wrongAnswersInRow;
};

export const getIsTooWrong = (state: GlobalState) => {
  return getWrongAnswers(state) >= 2;
};

export const getKnownBackendModules = (state: GlobalState) => {
  return state.config.modulesByName;
};

export const getModuleIdByBackendModuleType = (type: string, state: GlobalState) => {
  return state.config.modulesByName[type] || state.config.modulesByName[BackendModuleTypes.ANSWER_FLOW];
};

export const iaGreetedUser = (state: GlobalState) => {
  return state.ia.hasGreeted;
};

export const getLastIaQuestion = (state: GlobalState) => {
  return state.ia.lastQuestion;
};

export const getIAQueue = (state: GlobalState) => {
  return state.ia.queue;
};

export const getShowIAQuickActions = (state: GlobalState) => {
  return state.ia.showQuickActions && getIsIAFeedback(state);
};
